import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Solution } from '../components/Solution';
import { Benefits } from '../components/Benefits';
import { RecipeCategories } from '../components/RecipeCategories';
import { Bonuses } from '../components/Bonuses';
import { Pricing } from '../components/Pricing';
import { Guarantee } from '../components/Guarantee';
import { HowItWorks } from '../components/HowItWorks';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-brand-bg font-sans selection:bg-brand-accent/30" data-id="element-208">
      <Hero data-id="element-209" />
      <PainPoints data-id="element-210" />
      <Solution data-id="element-211" />
      <Benefits data-id="element-212" />
      <RecipeCategories data-id="element-213" />
      <Bonuses data-id="element-214" />
      <Pricing data-id="element-215" />
      <Guarantee data-id="element-216" />
      <HowItWorks data-id="element-217" />
      <Testimonials data-id="element-218" />
      <FAQ data-id="element-219" />
      <FinalCTA data-id="element-220" />

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-221">
        <div className="max-w-6xl mx-auto px-4" data-id="element-222">
          <p className="mb-2" data-id="element-223">
            © {new Date().getFullYear()} NoveliaHub. Todos los derechos
            reservados.
          </p>
          <p className="text-xs max-w-3xl mx-auto mt-4 text-gray-500" data-id="element-224">
            Descargo de responsabilidad: La información contenida en este sitio
            web y en el recetario tiene fines educativos e informativos
            únicamente y no sustituye el consejo, diagnóstico o tratamiento
            médico profesional. Siempre busque el consejo de su médico u otro
            proveedor de salud calificado con cualquier pregunta que pueda tener
            sobre una condición médica.
          </p>
        </div>
      </footer>
    </main>;
}